<!-- ################# SITE ################## -->

<!-- Global site tag (gtag.js) - Google Analytics -->
    <script async src="https://www.googletagmanager.com/gtag/js?id=UA-151323970-1"></script>
    <script>
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'UA-151323970-1');
    </script>

<!-- bootstrap core css -->

<style src="../../assets/site/css/font-awesome.min.css"></style>
<style src="../../assets/site/css/themify-icons.css"></style>
<style src="../../assets/site/css/magnific-popup.css"></style>
<style src="../../assets/site/css/owl.theme.default.min.css"></style>
<style src="../../assets/site/css/owl.carousel.min.css"></style>
<style src="../../assets/site/css/bootstrap.min.css"></style>
<style src="../../assets/site/css/style.css"></style>
<style src="../../assets/site/css/responsive.css"></style>
<script src="../../assets/site/js/vendor/modernizr-2.8.1.min.js"></script>


    <!-- HTML5 Shim and Respond.js for IE8 support of HTML5 elements and media queries -->
    <!-- WARNING: Respond.js doesn't work if you view the page via file:// -->
    <!--[if lt IE 9]>
    <script src="js/vendor/html5shim.js"></script>
    <script src="js/vendor/respond.min.js"></script>
    <![endif]-->
<!-- ################# SITE ################## -->


    

<template>
<div id="main" class="main-content-wraper">
    <div class="main-content-inner">

        <!--start header section-->
        <header class="header">
            <!--start navbar-->
            <div class="navbar navbar-default navbar-fixed-top">
                <div class="container">
                    <div class="row">
                        <div class="navbar-header page-scroll">
                            <button type="button" class="navbar-toggle collapsed" data-toggle="collapse"
                                    data-target="#myNavbar">
                                <span class="sr-only">Toggle navigation</span>
                                <span class="icon-bar"></span>
                                <span class="icon-bar"></span>
                                <span class="icon-bar"></span>
                            </button>
                        </div>

                        <!-- Collect the nav links, forms, and other content for toggling -->
                        <div class="navbar-collapse collapse" id="myNavbar">
                            <ul class="nav navbar-nav navbar-right">
                                <li><a href="/">Home</a></li>
                                <li><a href="/blog">Blog</a></li>
                                
                            </ul>
                        </div>

                    </div>
                </div>
            </div>
            <!--end navbar-->
        </header>
        <!--end header section-->

        <!--start breadcrumb section-->
        <section class="breadcrumb-section" style="background: url('img/download-bg.jpg')no-repeat center center fixed">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <div class="text-center breadcrumb-content">
                            
                            <h2>Vagas de janeiro de 2020 para educadores infantil</h2>
                            <p>Comece bem 2020 com novas oportunidades.</p>

                            <ul class="breadcrumb">
                                <li><a href="/">Home</a></li>
                                <li>Vagas de janeiro de 2020 para educadores infantil</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!--end breadcrumb section-->

        <!--start blog single section-->
        <section class="blog-details-area bg-secondary ptb-60">
            <div class="blog-details-area-wrap">
                <div class="container">
                    <div class="row">
                        <div class="col-md-8 col-md-offset-2">
                            <div class="blog-single-content-wrap">
                                <div class="blog-single-img">
                                    <a style="cursor:pointer" @click="goToInclass"><img src="https://firebasestorage.googleapis.com/v0/b/projetox-688ca.appspot.com/o/banners%2Fbanner-fb01.jpg?alt=media" style="width:100%; height:auto"></a>
                                    
                                </div>
                                <h1>Vagas para diversos estados</h1>
                                <div class="blog-details-post-meta">Postado <span>26 de janeiro de 2019</span> by InClass</div>
                                <div class="blog-details-text">
                                    <h4>Vagas para SP</h4><br />
                                    <b>
                                        Auxiliar de classe
                                    </b>
                                    <p><i>Estamos admitindo auxiliar de classe para inicio imediato. necessário experiencia em educação infantil para período integral com formação em pedagogia ...</i></p>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <!-- <v-btn flat color="primary" @click="cancel">Cancel</v-btn> -->
                                        <v-btn class="buttonOk" flat color="primary" target="_blank" href="https://www.infojobs.com.br/vaga-de-auxiliar-classe-educacao-infantil-em-sao-paulo__6712238.aspx">Ver mais!</v-btn>
                                    </v-card-actions>

                                    <hr />

                                     <b>
                                        Educador
                                    </b>
                                    <p><i>Desenvolver junto a coordenação o plano de ensino; Ministrar as aulas estimulando o desenvolvimento e aprendizado dos alunos; Avaliar o conhecimento adquirido em sala de aula; Promover e conduzir reunião de pais; Acompanhar a adaptação, comportamento e desenvolvimento de aprendizagem dos alunos; Auxiliar nas demais rotinas de sala de aula ...</i></p>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <!-- <v-btn flat color="primary" @click="cancel">Cancel</v-btn> -->
                                        <v-btn class="buttonOk" flat color="primary" target="_blank" href="https://www.infojobs.com.br/vaga-de-educador-educacao-infantil-em-sao-paulo__6698739.aspx">Ver mais!</v-btn>
                                    </v-card-actions>

                                    <hr />

                                    <b>
                                        Professor de educação infantil
                                    </b>
                                    <p><i>Descrição:Benefícios: VT + Refeitório e alimentação no empresa: Creche/ Escola Infantil/ Maternal/ JardimLocalização da Vaga: Bairro Tristeza, Porto AlegreHorário: Segunda à Sexta - 9h30 às 18h30 com intervalo - 40 horas semanaisAtividades: Responsável nas elaborações de projetos pedagógicos conforme a faixa etária, troca de fraldas (se necessário), elaboração de rotina semana, liderança de turma, preenchimento de agenda escolar e reunião ...</i></p>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <!-- <v-btn flat color="primary" @click="cancel">Cancel</v-btn> -->
                                        <v-btn class="buttonOk" flat color="primary" target="_blank" href="https://www.trabalhabrasil.com.br/vagas-empregos-em-sao-paulo-sp/professor-de-educacao-infantil/4927877">Ver mais!</v-btn>
                                    </v-card-actions>

                                    <hr />

                                    <b>
                                        Professor de educação infantil
                                    </b>
                                    <p><i>Área de especialização Profissional: Educação, Ensino particular Nível hierárquico: Operacional Local de trabalho: OsascoJornada Período IntegralSomos uma empresa especializada em robótica pedagógica para alunos da educação infantil e ensino fundamental 1 em colégio particulares parceiros. Atuar na função de orientadora (professora) nas aulas de robótica pedagógica, recebera treinamento da : Carro próprio para deslocamento até os colégios ...</i></p>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <!-- <v-btn flat color="primary" @click="cancel">Cancel</v-btn> -->
                                        <v-btn class="buttonOk" flat color="primary" target="_blank" href="https://www.trabalhabrasil.com.br/vagas-empregos-em-sao-paulo-sp/professor-de-educacao-infantil/4941108">Ver mais!</v-btn>
                                    </v-card-actions>

                                    <hr />

                                    <b>
                                        Professor de educação infantil
                                    </b>
                                    <p><i>Lecionar para alunos de educacao infantil período da tarde ...</i></p>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <!-- <v-btn flat color="primary" @click="cancel">Cancel</v-btn> -->
                                        <v-btn class="buttonOk" flat color="primary" target="_blank" href="https://br.jobrapido.com/jobpreview/72611175">Ver mais!</v-btn>
                                    </v-card-actions>

                                    <hr />

                                    <b>
                                        Professor de educação infantil
                                    </b>
                                    <p><i>Professor de educação infantil Irá ministrar aulas e alfabetização, auxiliar os alunos, entre outras atividades da área. Beneficios: A Combinar; Formação Acadêmica: Ensino superior completo. Experiência: Conhecimento e experiência em alfabetização. Salário: A combinar Cargo: Professor de Educação Infantil Empresa: Plus Solucao Aulas particulares, cursos preparatórios, treinamentos e consultoria empresarial. Ramo: Educação/ Treinamento/ Idiomas ...</i></p>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <!-- <v-btn flat color="primary" @click="cancel">Cancel</v-btn> -->
                                        <v-btn class="buttonOk" flat color="primary" target="_blank" href="https://www.bebee.com/br/job/professor-educacao-infantil-54933377">Ver mais!</v-btn>
                                    </v-card-actions>

                                    <hr />

                                    <a style="cursor:pointer" @click="goToInclass"><img src="https://firebasestorage.googleapis.com/v0/b/projetox-688ca.appspot.com/o/banners%2Fbanner-fb01.jpg?alt=media" style="width:100%; height:auto"></a>

                                    <h4>Vagas para RJ</h4><br />
                                    <b>
                                        Professora Educação Infantil
                                    </b>
                                    <p><i>Vaga para Professor de educação infantil, ensino fundamental I e II e ensino médio (todas as disciplinas). experiência sólida, formação compatível com a função ...</i></p>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <!-- <v-btn flat color="primary" @click="cancel">Cancel</v-btn> -->
                                        <v-btn class="buttonOk" flat color="primary" target="_blank" href="https://www.trabalhabrasil.com.br/vagas-empregos-em-rio-de-janeiro-rj/professor-de-educacao-infantil/4970850">Ver mais!</v-btn>
                                    </v-card-actions>

                                    <hr />

                                    <b>
                                        Professora Educação Infantil
                                    </b>
                                    <p><i>Salário compatível com o mercado + Vale Transporte + Almoço no local ...</i></p>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <!-- <v-btn flat color="primary" @click="cancel">Cancel</v-btn> -->
                                        <v-btn class="buttonOk" flat color="primary" target="_blank" href="https://rjempregos.net/vaga/professora-educacao-infantil-curicica-rj/">Ver mais!</v-btn>
                                    </v-card-actions>

                                    <hr />

                                    <b>
                                        Professora de Educação Infantil – Creche – Recreio dos Bandeirantes
                                    </b>
                                    <p><i>Professora de Educação Infantil primeira etapa da Educação Básica ...</i></p>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <!-- <v-btn flat color="primary" @click="cancel">Cancel</v-btn> -->
                                        <v-btn class="buttonOk" flat color="primary" target="_blank" href="https://rjempregos.net/vaga/professora-de-educacao-infantil-creche-recreio-dos-bandeirantes">Ver mais!</v-btn>
                                    </v-card-actions>

                                    <hr />

                                    <b>
                                        Professora Educação Infantil Bilíngue
                                    </b>
                                    <p><i>Preparar planejamentos semestrais, mensais e semanais; Elaboração de planejamento pedagógico online; Produção de Sway com fotos mensais dos alunos para envio aos responsáveis; Participar de Coaching Pedagógicos semanalmente; Participar dos momentos de Educação Continuada; Corrigir cadernos, livros e avaliações; Ajudar os alunos com higiene pessoal; Desenvolver projetos e atividades criativas e artísticas ...</i></p>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <!-- <v-btn flat color="primary" @click="cancel">Cancel</v-btn> -->
                                        <v-btn class="buttonOk" flat color="primary" target="_blank" href="https://www.google.com/search?ibp=htl;jobs&hl=pt-BR&kgs=bd833dc5d34f2ce5&q=vagas+ensino+infantil+RJ&shndl=-1&source=sh/x/im/textlists/detail&entrypoint=sh/x/im/textlists/detail#fpstate=tldetail&htidocid=6uHpXv8fQc7lvGwaAAAAAA%3D%3D&htiq=vagas+ensino+infantil+RJ&htivrt=jobs">Ver mais!</v-btn>
                                    </v-card-actions>

                                    <hr />

                                    <b>
                                        Cozinheira, Auxiliar de Cozinha, Auxiliar de Creche e Estágio de Educação...
                                    </b>
                                    <p><i>CENTRO EDUCACIONAL ESPAÇO INFANTIL* , estamos buscando profissionais de diversos perfis ...</i></p>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <!-- <v-btn flat color="primary" @click="cancel">Cancel</v-btn> -->
                                        <v-btn class="buttonOk" flat color="primary" target="_blank" href="https://rjempregos.net/vaga/cozinheira-auxiliar-de-cozinha-auxiliar-de-creche-e-estagio-de-educacao-infantil-rio-de-janeiro/">Ver mais!</v-btn>
                                    </v-card-actions>

                                    <hr />
                                    
                                    <h4>Vagas para GO</h4><br />

                                    <b>
                                        Professor de inglês para educação infantil e ensino fundamental
                                    </b>
                                    <p><i>Atuará ministrando aula de idioma ...</i></p>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <!-- <v-btn flat color="primary" @click="cancel">Cancel</v-btn> -->
                                        <v-btn class="buttonOk" flat color="primary" target="_blank" href="https://neuvoo.com.br/view/?id=7a151ecaffcb&utm_campaign=google_jobs_apply&utm_source=google_jobs_apply&utm_medium=organic">Ver mais!</v-btn>
                                    </v-card-actions>

                                    <hr />

                                    <b>
                                        Professor de Educação Infantil e Fundamental I
                                    </b>
                                    <p><i>Você irá ministrar aulas teóricas e práticas estudantes da educação infantil e fundamental I, conforme orientação e conteúdo programático ...</i></p>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <!-- <v-btn flat color="primary" @click="cancel">Cancel</v-btn> -->
                                        <v-btn class="buttonOk" flat color="primary" target="_blank" href="https://www.recrutasimples.com.br/vaga/professor-de-educacao-infantil-e-fundamental-i/aparecida-de-goiania-go/-Ly-ObJyvMaQLnx5Yjjs">Ver mais!</v-btn>
                                    </v-card-actions>

                                     <hr />

                                    <h4>Vagas para MG</h4><br />

                                    <b>
                                        Professor de Educação Infantil
                                    </b>
                                    <p><i>Irá atuar na educação infantil, no horário de 7h às 17h. Oferecemos, vale transporte, assistência médica e odontológico co-participativo e alimentação na empresa. Instituição conveniada com a pbh na regional oeste.é necessário experiência com crianças ...</i></p>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <!-- <v-btn flat color="primary" @click="cancel">Cancel</v-btn> -->
                                        <v-btn class="buttonOk" flat color="primary" target="_blank" href="https://www.trabalhabrasil.com.br/vagas-empregos-em-belo-horizonte-mg/professor-de-educacao-infantil/2696192">Ver mais!</v-btn>
                                    </v-card-actions>


                                    <br /><br />
                                    <a style="cursor:pointer" @click="goToInclass"><img src="https://firebasestorage.googleapis.com/v0/b/projetox-688ca.appspot.com/o/banners%2Fbanner-fb01.jpg?alt=media" style="width:100%; height:auto"></a>
                                    <br /><br />
                                    
                                </div>
                                <div class="row" style="display:none">
                                    <!--start comments section-->
                                    <div class="col-sm-12">
                                        <h3 class="blog-details-subtitle">Comentários</h3>
                                        <ul class="blog-comments">
                                            <li>
                                                <img src="img/t2.jpg" alt="">
                                                <div class="blog-comment-author">
                                                    <h6>Lillie J. Yates</h6>
                                                    <a href="#" class="active"> Reply </a>
                                                    <span>Dec 26, 2017 at 15:35</span>
                                                    <p>Continually leverage existing distinctive sources after excellent data. Interactively evolve enterprise leadership skills vis-a-vis.</p>
                                                </div>
                                            </li>
                                            <li class="reply">
                                                <img src="img/t3.jpg" alt="">
                                                <div class="blog-comment-author">
                                                    <h6>Todd B. Tucker</h6>
                                                    <a href="#"> Reply </a>
                                                    <span>Jan 16, 2018 at 04:35</span>
                                                    <p>Professionally envisioneer enabled interfaces vis-a-vis plug-and-play supply chains. Competently benchmark real-time value without process-centric.</p>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                    <!--end comments section-->

                                    <!--start comment form-->
                                    <form class="col-sm-12 comment-form send-message">
                                        <h3 class="blog-details-subtitle">Leave a Reply</h3>
                                        <div class="row">
                                            <!--Name-->
                                            <div class="col-md-6">
                                                <input class="comment-input-field" type="text" placeholder="Name">
                                            </div>
                                            <!--Email-->
                                            <div class="col-md-6">
                                                <input class="comment-input-field" type="text" placeholder="Email">
                                            </div>
                                            <!--Message-->
                                            <div class="col-md-12">
                                                <textarea name="comment-message" placeholder="Message" rows="5"></textarea>
                                            </div>
                                        </div>
                                        <input class="btn softo-solid-btn" type="submit" value="Send">

                                    </form>
                                    <!--end comment form-->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!--end blog single section-->

        <!--start footer section-->
        <!--start footer section-->
        <footer class="footer-section bg-secondary ptb-60">
            <div class="footer-wrap">
                <div class="container">
                    <div class="row">
                        <div class="col-md-6 col-md-offset-3">
                            <div class="footer-single-col text-center">
                                <img src="@/assets/site/img/logo-color.png" alt="footer logo" style="display:none">
                                <div class="footer-social-list">
                                    <ul class="list-inline">
                                        <li><a href="https://www.facebook.com/app.inclass" target="_blank"> <i class="fa fa-facebook"></i></a></li>
                                        <!-- <li><a href="#"> <i class="fa fa-twitter"></i></a></li> -->
                                        <li><a href="#"> <i class="fa fa-linkedin"></i></a></li>
                                        <!-- <li><a href="#"> <i class="fa fa-google-plus"></i></a></li> -->
                                        <li><a href="https://www.youtube.com/channel/UCpS1fZ6eIGeKLK3VUlnYibw" target="_blank"> <i class="fa fa-youtube"></i></a></li>
                                    </ul>
                                </div>
                                <div class="copyright-text">
                                    <p>&copy; copyright <a href="#">InClass</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
        <!--end footer section-->

    </div><!--end main content inner-->
            
</div>
<!--end main container -->        
</template>



<!-- custom script -->
<!--script src="../../assets/site/js/scripts.js" defer></script-->

<script>
import Vue from 'vue';

import db from '@/components/firebaseInit';
import firebase,{ storage } from 'firebase';

import VueMeta from 'vue-meta';
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})

import vueSmoothScroll from 'vue2-smooth-scroll'
Vue.use(vueSmoothScroll)

export default {
    name: 'cadsite',
    metaInfo: {
      title: 'Blog InClass',
    //   meta: [
    //     { charset: 'utf-8' },
    //     { name: 'viewport', content: 'width=device-width, initial-scale=1' }
    //   ]
//         meta: [
//         //    { name: 'description', content: 'Qual é a melhor idade para aprender inglês?' },
//         //    { name: 'og:url', content: 'https://www.inclass.app' },
//         //    { name: 'og:title', content: 'Blog InClass' },
//         //    { name: 'og:image', content: 'https://i.catracalivre.com.br/Za23hBkAFSCnzjBMa_-LXSe8ukM=/https%3A%2F%2Fcatracalivre.com.br%2Fwp-content%2Fuploads%2F2019%2F01%2Fistock-599956378.jpg' }




// // OpenGraph data (Most widely used)
//     {property: 'og:title', content: 'My Page Title ← My Site'},
//     {property: 'og:site_name', content: 'My Site'},
//     // The list of types is available here: http://ogp.me/#types
//     {property: 'og:type', content: 'website'},
//     // Should the the same as your canonical link, see below.
//     {property: 'og:url', content: 'https://inclass.app/blog/idade-para-aprender-ingles'},
//     {property: 'og:image', content: 'https://i.catracalivre.com.br/Za23hBkAFSCnzjBMa_-LXSe8ukM=/https%3A%2F%2Fcatracalivre.com.br%2Fwp-content%2Fuploads%2F2019%2F01%2Fistock-599956378.jpg'},
//     // Often the same as your meta description, but not always.
//     {property: 'og:description', content: 'I have things here on my site.'},

//     // Twitter card
//     {name: 'twitter:card', content: 'summary'},
//     {name: 'twitter:site', content: 'https://inclass.app/blog/idade-para-aprender-ingles'},
//     {name: 'twitter:title', content: 'My Page Title ← My Site'},
//     {name: 'twitter:description', content: 'I have things here on my site.'},
//     // Your twitter handle, if you have one.
//     {name: 'twitter:creator', content: '@alligatorio'},
//     {name: 'twitter:image:src', content: 'https://i.catracalivre.com.br/Za23hBkAFSCnzjBMa_-LXSe8ukM=/https%3A%2F%2Fcatracalivre.com.br%2Fwp-content%2Fuploads%2F2019%2F01%2Fistock-599956378.jpg'},

//     // Google / Schema.org markup:
//     {itemprop: 'name', content: 'My Page Title ← My Site'},
//     {itemprop: 'description', content: 'I have things here on my site.'},
//     {itemprop: 'image', content: 'https://i.catracalivre.com.br/Za23hBkAFSCnzjBMa_-LXSe8ukM=/https%3A%2F%2Fcatracalivre.com.br%2Fwp-content%2Fuploads%2F2019%2F01%2Fistock-599956378.jpg'}









//            //$('head').append('<meta property="og:type" content="profile"/>'); 
//             //$('head').append('<meta property="og:url" content=""/>');
//             //$('head').append("<meta property='og:title' content="+text+"'/>");
//             //$('head').append("<meta property='og:image' content="+imageUrl+"'/>");
//         ]
    },
    data() {
        return {
            nome: '',
            telefone: '',
            email: '',
            celular: '',
            escola: '',
            mensagem: ''
        };
    },
    methods: {
        enviarFormularioContato(){
            // timestamp
                var now = new Date();
                var year = "" + now.getFullYear();
                var month = "" + (now.getMonth() + 1); if (month.length == 1) { month = "0" + month; }
                var day = "" + now.getDate(); if (day.length == 1) { day = "0" + day; }
                var hour = "" + now.getHours(); if (hour.length == 1) { hour = "0" + hour; }
                var minute = "" + now.getMinutes(); if (minute.length == 1) { minute = "0" + minute; }
                var second = "" + now.getSeconds(); if (second.length == 1) { second = "0" + second; }
                //return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
                var customtimestamp = year + month + day + hour + minute + second
                db.collection('contato').add({
                    customtimestamp: customtimestamp,
                    nome: day,
                    mes: month,
                    ano: year,
                    nome: this.nome,
                    email: this.email,
                    celular: this.celular
                    
                })
                .then(docRef => {
                    console.log('Document written with ID: ', docRef.id);
                    alert("Formulário enviado com sucesso. Entraremos em contato em breve!")
                    
                })
                .catch(function (error) {
                    console.log('Error adding document: ', error);
                    alert("Ops! Tivemos um probleminha ao enviar os dados do formulário. Por favor, tente novamente!")
                })
        },
        goToInclass(){
            // Google Analytics - Events
            gtag('event', 'clicou', {
                'event_category': '/blog/vagas-educacao-infantil-janeiro-2020',
                'event_label': 'banner'//,
                //'value': '<value>'
            });

            window.location.href = "/";
        }
    },
    created() {
    }
}





$(document).ready(function(){
    

    // ### Clique para download do app
    let deferredPrompt;

    window.addEventListener('beforeinstallprompt', function(event) {
      // Prevent Chrome 67 and earlier from automatically showing the prompt
      event.preventDefault();
      // Stash the event so it can be triggered later.
      deferredPrompt = event;
    });

    // ### INICIO - para o IOS - Download
    $("#bntAddFnIOS, #bntAddFnIOS2").click(function(){
        $(".custom-modal-ios").show();
        // alert("a");
        // // Detecta se o dispositivo está no iOS
        // const isIos = () => {
        //     const userAgent = window.navigator.userAgent.toLowerCase();
        //     return /iphone|ipad|ipod/.test( userAgent );
        // }
        // // Detects if device is in standalone mode
        // const isInStandaloneMode = () => ('standalone' in window.navigator) && (window.navigator.standalone);
        // // Verifica se deve exibir notificação popup de instalação:
        // if (isIos() && !isInStandaloneMode()) {
        //     this.setState({ showInstallMessage: true });
        // }
    })
    // ### FIM - para o IOS

    // Installation must be done by a user gesture! Here, the button click
    var btnAdd = document.getElementById("bntAddFn");
    btnAdd.addEventListener('click', (e) => {
      // hide our user interface that shows our A2HS button
      //btnAdd.style.display = 'none';
      // Show the prompt
      deferredPrompt.prompt();
      // Wait for the user to respond to the prompt
      deferredPrompt.userChoice
        .then((choiceResult) => {
          if (choiceResult.outcome === 'accepted') {
            console.log('User accepted the A2HS prompt');
          } else {
            console.log('User dismissed the A2HS prompt');
          }
          deferredPrompt = null;
        });
    });

    // Installation must be done by a user gesture! Here, the button click
    var btnAdd = document.getElementById("download-app-button");
    btnAdd.addEventListener('click', (e) => {
      // hide our user interface that shows our A2HS button
      //btnAdd.style.display = 'none';
      // Show the prompt
      deferredPrompt.prompt();
      // Wait for the user to respond to the prompt
      deferredPrompt.userChoice
        .then((choiceResult) => {
          if (choiceResult.outcome === 'accepted') {
            console.log('User accepted the A2HS prompt');
          } else {
            console.log('User dismissed the A2HS prompt');
          }
          deferredPrompt = null;
        });
    });

    // Installation must be done by a user gesture! Here, the button click
    var btnAdd = document.getElementById("download-app-button-win");
    btnAdd.addEventListener('click', (e) => {
      // hide our user interface that shows our A2HS button
      //btnAdd.style.display = 'none';
      // Show the prompt
      deferredPrompt.prompt();
      // Wait for the user to respond to the prompt
      deferredPrompt.userChoice
        .then((choiceResult) => {
          if (choiceResult.outcome === 'accepted') {
            console.log('User accepted the A2HS prompt');
          } else {
            console.log('User dismissed the A2HS prompt');
          }
          deferredPrompt = null;
        });
    });


    $(".softo-btn-outline").click(function(){
        window.location.href = "#contact";
    })




    $(".navbar-toggle.collapsed").click(function(){
        if ($('#myNavbar').is(":visible"))
        {
            $("#myNavbar").slideUp('fast');
        }
        else{
            $("#myNavbar").slideDown('fast');
        }
        
    })

    $(".product-counter-section.ptb-40, #features, .promo-section.bg-secondary.ptb-90, #pricing, .testimonial-section.bg-secondary.ptb-90, #faqs").click(function(){
        $("#myNavbar").slideUp('fast');
    })

    $("#accordion .panel-heading").click(function(){
        if ($(this).parent().find(".collapse").is(":visible"))
        {
            $(this).parent().find("div.collapse").slideUp();
            $(this).find("h4 a").addClass("collapsed")
            $(this).find("h4 a").removeClass("collapse")
        }
        else{
            $(this).parent().find("div.collapse").slideDown();
            $(this).find("h4 a").removeClass("collapsed")
            $(this).find("h4 a").addClass("collapse")
        }
        
    })

    $("#myNavbar a").click(function(){
        $("#myNavbar").slideUp('fast');
    })

    $(".video").click(function(){
        $(".custom-modal").fadeIn("fast");
        $(".custom-modal-ios").hide();
    })

    $(".shadow, .fechar, .content").click(function(){
        $('.video-youtube').each(function(){
            var el_src = $(this).attr("src");
            $(this).attr("src",el_src);
        });
        $(".custom-modal").fadeOut("fast");
    })


    $("a").click(function(){
        gtag('event', 'clicou', {
            'event_category': '/site',
            'event_label': $(this).text()//,
            // 'value': '<value>'
        });
    })

    


// Pixel do Facebook
!function(f,b,e,v,n,t,s)
  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t,s)}(window, document,'script',
  'https://connect.facebook.net/en_US/fbevents.js');
  fbq('init', '139700983684961');
  fbq('track', 'PageView');

  // Evento do facebook - visualizaçao de conteudo    
  fbq('track', 'ViewContent');
})



</script>
<style>
    .hidden-sm-and-down, .hidden-sm-and-down a{
        display: none !important;
    }

    .breadcrumb-section{
        padding-top: 90px !important;
    }

    #myNavbar ul{
        position: relative;
        top: -19px;
    }

    h4{
        color: orange
    }

    b{
        color: #5a1e82;
    }

</style>